import React from "react";
import { Link } from "react-router-dom";

const StationSettingsTable = ({ settingList, handleEnable, handleDisable, scopeType}) => {
    const getEmptyMessage = () => {
        switch (scopeType) {
            case "global":
                return "No global station settings added yet.";
            case "school":
                return "No school station settings added yet.";
            case "station":
                return "No single station settings added yet.";
            default:
                return "No station settings added yet.";
        }
    };

    return (
        <table className="table display data-table text-nowrap">
        <thead>
        <tr>
            <th>No.</th>
            <th>Authentication Method</th>
            {scopeType === "school" && <th>School</th>}
            {scopeType === "station" && <th>Station / Booth</th>}
            <th>Last Update</th>
            <th>Status</th>
            <th>Actions</th>
        </tr>
        </thead>
        <tbody>
            {Array.isArray(settingList) && settingList.map((item, index) => (
                <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.auth_method}</td>
                {scopeType === "school" && <td>{item.school_name}</td>}
                {scopeType === "station" && <td>{item.station_name}<br/><small>{item.station_code}</small></td>}
                <td>{item.updated_at?.short_date}<br/><small>{item.set_by}</small></td>
                <td>{item.is_disabled === "1" ? <span className="badge badge-danger">DISABLED</span> : <span className="badge badge-success">ENABLED</span>}</td>
                    <td>
                        <div className="dropdown">
                            <Link
                            to="#"
                            className="dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false">
                            <span className="flaticon-more-button-of-three-dots"></span>
                            </Link>
                            <div className="dropdown-menu dropdown-menu-right">
                            {item.is_disabled === "1" ?<Link
                                className="dropdown-item"
                                to="#"
                                onClick={(e) => handleEnable(e,item)}>
                                <i className="far fa-edit mr-1" style={{color:"green"}}></i>
                                Enable Authentication
                            </Link>:<Link
                                className="dropdown-item"
                                to="#"
                                onClick={(e) => handleDisable(e,item)}>
                                <i className="far fa-edit mr-1" style={{color:"red"}}></i>
                                Disable Authentication
                            </Link>}
                            </div>
                        </div>
                    </td>
                </tr>
            )
            
            )}
            {settingList === "404" && (<tr>
                <td colSpan={scopeType === "school" ||scopeType === "station"  ? "6" : "5"} style={{ textAlign: "center" }}>
                    {getEmptyMessage()}
                </td>
            </tr>)}
        </tbody>
        </table>
    );
};

export default StationSettingsTable;
